import { useState } from "react";

const ServiceCard = ({
  title,
  subtitle,
  backgroundImage,
  bgColor,
  expandedContent,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <div className="w-full mb-6">
      {/* Collapsed Card */}
      <div
        className="relative w-full rounded-3xl overflow-hidden cursor-pointer transform transition-all duration-300 shadow-lg"
        style={{
          // Dynamic height based on expanded state and screen size
          height: isExpanded ? "auto" : "300px",
          minHeight: isExpanded
            ? "400px" // Minimum height when expanded for mobile
            : "300px",
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        onClick={toggleExpanded}
      >
        {/* Dark overlay for better text readability */}
        <div className="bg-[#233D5D78] bg-[#FCC9682B] bg-[#233D5D78] bg-[#0000003D] bg-[#03A58E30] bg-[#5B8AC961] hidden" />
        <div className={`absolute inset-0 bg-[${bgColor}]`}></div>

        {/* Content */}
        <div
          className={`relative z-10 h-full flex flex-col justify-center items-center text-white text-center transition-all duration-300 ${
            isExpanded
              ? "p-4 sm:p-6 md:p-8 py-8 sm:py-10 md:py-12" // More padding when expanded, especially on mobile
              : "p-8"
          }`}
        >
          <h3
            className={`font-bold mb-4 ${
              isExpanded
                ? "text-2xl sm:text-3xl md:text-4xl" // Responsive text sizing
                : "text-3xl md:text-4xl"
            }`}
          >
            {title}
          </h3>

          {/* Subtitle - only show when expanded */}
          {/* {isExpanded && ( */}
          <p
            className={`font-light max-w-3xl mx-auto leading-relaxed transition-all duration-500 mb-6 overflow-hidden ${
              isExpanded ? "max-h-[500px]" : "max-h-0"
            } text-base sm:text-lg md:text-xl`}
            style={{
              lineHeight: "1.6",
            }}
          >
            {subtitle}
          </p>

          {/* )}s */}

          {/* Learn More Button */}
          <button
            className="flex items-center gap-2 px-4 sm:px-6 py-2 sm:py-3 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full text-white transition-all duration-300 backdrop-blur-sm mt-auto"
            onClick={(e) => {
              e.stopPropagation();
              toggleExpanded();
            }}
          >
            <span className="text-xs sm:text-sm font-medium">
              {isExpanded ? "Show Less" : "Learn More"}
            </span>
            <div className="flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 bg-white rounded-full">
              <svg
                className={`w-2.5 h-2.5 sm:w-3 sm:h-3 text-blue-900 transition-transform duration-300 ${
                  isExpanded ? "rotate-[-90deg]" : ""
                }`}
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
